module.exports = __webpack_public_path__ + "img/logo.f67405d6.png";